import { create } from 'zustand';

const SESSION_KEY = 'gn:session';

function initialHasSession(): boolean {
  if (typeof window === 'undefined') return false;
  localStorage.removeItem('gn:refresh');
  return localStorage.getItem(SESSION_KEY) === '1';
}

export interface AuthState {
  accessToken: string | null;
  hasSession: boolean;
  setAccessToken: (access: string | null, hasSession?: boolean) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  hasSession: initialHasSession(),
  setAccessToken: (access, hasSession = true) => {
    if (hasSession) localStorage.setItem(SESSION_KEY, '1');
    else localStorage.removeItem(SESSION_KEY);
    set({ accessToken: access, hasSession });
  },
  clear: () => {
    localStorage.removeItem(SESSION_KEY);
    set({ accessToken: null, hasSession: false });
  },
}));
